<p-confirmDialog key="school" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="district" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="user" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--School Settings-->
				<div class="MenuBorder">
					<h3 style="text-align: center">School Settings:</h3>

					<div class="SchoolSelectGrid">
						<label>School:</label>
						<caass-schoolselector [Disabled]="IsSchoolLoading()" [ShowAll]="false"> </caass-schoolselector>
					</div>

					<div>
						<h4 class="TopMargin" style="text-align: center">Students Information</h4>

						<div class="InfoGrid">
							<label for="SchoolHideStudentID">Hide Student ID (display ********** instead)</label>
							<input
								[disabled]="IsSchoolLoading() == true"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="SchoolHideStudentID"
								id="SchoolHideStudentID"
							/>

							<label for="SchoolFirstName">Hide First Name (display ********** instead)</label>
							<input
								[disabled]="IsSchoolLoading() == true"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="SchoolFirstName"
								id="SchoolFirstName"
							/>

							<label for="SchoolLastName">Hide Last Name (display ********** instead)</label>
							<input
								[disabled]="IsSchoolLoading() == true"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="SchoolLastName"
								id="SchoolLastName"
							/>

							<label for="SchoolHideBusPosition">Hide Bus Positions (won't show on map)</label>
							<input
								[disabled]="IsSchoolLoading() == true"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="SchoolHideBusPosition"
								id="SchoolHideBusPosition"
							/>

							<label for="SchoolHideStudentSwipeOn">Hide Student Swipe On (won't show on map)</label>
							<input
								[disabled]="IsSchoolLoading() == true"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="SchoolHideStudentSwipeOn"
								id="SchoolHideStudentSwipeOn"
							/>

							<label for="SchoolHideStudentSwipeOff">Hide Student Swipe Off (won't show on map)</label>
							<input
								[disabled]="IsSchoolLoading() == true"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="SchoolHideStudentSwipeOff"
								id="SchoolHideStudentSwipeOff"
							/>
						</div>
					</div>

					<div class="TopMargin">
						<p-accordion>
							<p-accordionTab
								header="School Default Position {{ SchoolMapExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
								[(selected)]="SchoolMapExpand"
							>
								<div>
									<p-gmap
										#SchoolMap
										*ngIf="ShowSchoolMap == true"
										[overlays]="overlays"
										[options]="SchoolOptions"
										[style]="{
											width: '100%',
											height: '625px'
										}"
									></p-gmap>
								</div>
							</p-accordionTab>
						</p-accordion>
					</div>

					<div class="TopMargin CenterText">
						<button class="btn btn-primary" [disabled]="IsSchoolLoading() == true" (click)="onUpdateSchool()">Update</button>
						<button class="btn btn-danger" style="margin-left: 5px" [disabled]="IsSchoolLoading() == true" (click)="onResetSchool()">
							Reset to District
						</button>
					</div>
				</div>

				<!--District Settings-->
				<div class="MenuBorder TopMargin">
					<h3 style="text-align: center">District Settings:</h3>

					<div>
						<h4 class="TopMargin" style="text-align: center">Students Information</h4>

						<div class="InfoGrid">
							<label for="DistrictHideStudentID">Hide Student ID (display ********** instead)</label>
							<input
								[disabled]="IsDistrictLoading() == true || CanEditDistrict() == false"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="DistrictHideStudentID"
								id="DistrictHideStudentID"
							/>

							<label for="DistrictFirstName">Hide First Name (display ********** instead)</label>
							<input
								[disabled]="IsDistrictLoading() == true || CanEditDistrict() == false"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="DistrictFirstName"
								id="DistrictFirstName"
							/>

							<label for="DistrictLastName">Hide Last Name (display ********** instead)</label>
							<input
								[disabled]="IsDistrictLoading() == true || CanEditDistrict() == false"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="DistrictLastName"
								id="DistrictLastName"
							/>

							<label for="DistrictHideBusPosition">Hide Bus Positions (won't show on map)</label>
							<input
								[disabled]="IsDistrictLoading() == true || CanEditDistrict() == false"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="DistrictHideBusPosition"
								id="DistrictHideBusPosition"
							/>

							<label for="DistrictHideStudentSwipeOn">Hide Student Swipe On (won't show on map)</label>
							<input
								[disabled]="IsDistrictLoading() == true || CanEditDistrict() == false"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="DistrictHideStudentSwipeOn"
								id="DistrictHideStudentSwipeOn"
							/>

							<label for="DistrictHideStudentSwipeOff">Hide Student Swipe Off (won't show on map)</label>
							<input
								[disabled]="IsDistrictLoading() == true || CanEditDistrict() == false"
								class="form-control CHK"
								type="checkbox"
								[(ngModel)]="DistrictHideStudentSwipeOff"
								id="DistrictHideStudentSwipeOff"
							/>
						</div>
					</div>

					<div>
						<h4 class="TopMargin" style="text-align: center">Import Settings</h4>

						<div class="InfoGrid">
							<label for="OutOfDateEmailEnabled">Send Email if Import Files are Outdated</label>
							<input
								[disabled]="IsDistrictLoading() == true || CanEditDistrict() == false"
								class="form-control CHK"
								style="margin-right: auto; width: fit-content"
								type="checkbox"
								[(ngModel)]="OutOfDateEmailEnabled"
								id="OutOfDateEmailEnabled"
							/>

							<label>Send Email if file is older than x hours (Import usually runs at 8pm)</label>
							<input
								[disabled]="IsDistrictLoading() == true || CanEditDistrict() == false"
								class="form-control"
								type="number"
								[(ngModel)]="OutOfDateHours"
							/>

							<label>Send Error Email to (Separate multiple with ;)</label>
							<input
								[disabled]="IsDistrictLoading() == true || CanEditDistrict() == false"
								class="form-control"
								style="min-width: 350px"
								type="text"
								[(ngModel)]="ErrorEmailList"
								placeholder="Ex. jdoe@access411.com;jdoe2@access411.com"
							/>
						</div>
					</div>

					<div class="TopMargin">
						<p-accordion>
							<p-accordionTab
								header="District Default Position {{ DistrictMapExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
								[(selected)]="DistrictMapExpand"
							>
								<div>
									<p-gmap
										#DistrictMap
										*ngIf="ShowDistrictMap == true"
										[overlays]="overlays"
										[options]="DistrictOptions"
										[style]="{
											width: '100%',
											height: '625px'
										}"
									></p-gmap>
								</div>
							</p-accordionTab>
						</p-accordion>
					</div>

					<div class="TopMargin CenterText">
						<button class="btn btn-primary" [disabled]="IsDistrictLoading() == true || CanEditDistrict() == false" (click)="onUpdateDistrict()">
							Update
						</button>
					</div>
				</div>

				<!--User Settings-->
				<div class="MenuBorder TopMargin">
					<h3 style="text-align: center">User Settings:</h3>

					<div class="TopMargin">
						<p-accordion>
							<p-accordionTab
								header="User Default Position {{ UserMapExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
								[(selected)]="UserMapExpand"
							>
								<div>
									<p-gmap
										#UserMap
										*ngIf="ShowUserMap == true"
										[overlays]="overlays"
										[options]="UserOptions"
										[style]="{
											width: '100%',
											height: '625px'
										}"
									></p-gmap>
								</div>
							</p-accordionTab>
						</p-accordion>
					</div>

					<div class="TopMargin CenterText">
						<button class="btn btn-primary" [disabled]="IsDistrictLoading() == true" (click)="onUpdateUser()">Update</button>
						<button class="btn btn-danger" style="margin-left: 5px" [disabled]="IsDistrictLoading() == true" (click)="onResetUser()">
							Reset to District
						</button>
					</div>
				</div>

				<!--SU Only Settings-->
				<div *ngIf="IsSU() == true" class="MenuBorder TopMargin">
					<h3 style="text-align: center">SU Only Settings:</h3>

					<div>
						<h4 class="TopMargin" style="text-align: center">Hide Information</h4>

						<div class="InfoGrid">
							<label>Hide String (Replaces Student ID or Full Name)</label>
							<input [disabled]="IsSULoading() == true" class="form-control CHK" type="text" [(ngModel)]="HideString" />

							<label>Hide Half String (Replaces First Name, or Last Name, ex. John **** or **** Doe)</label>
							<input [disabled]="IsSULoading() == true" class="form-control CHK" type="text" [(ngModel)]="HideStringHalf" />
						</div>
					</div>

					<div>
						<h4 class="TopMargin" style="text-align: center">Sounds</h4>

						<div class="InfoGrid">
							<label>Accident</label>
							<p-dropdown
								[disabled]="IsSULoading() == true"
								[options]="lstSounds"
								[(ngModel)]="AccidentHighSound"
								optionLabel="SoundFile"
								[filter]="true"
								filterBy="SoundFile"
								[showClear]="false"
								placeholder="Select a Sound"
							>
								<ng-template pTemplate="selectedItem">
									<div *ngIf="AccidentHighSound">
										<div class="form-control NoBorder" style="text-align: left">
											{{ AccidentHighSound.SoundFile }}
										</div>
									</div>
								</ng-template>
								<ng-template let-SoundItem pTemplate="item">
									<div>
										<div class="form-control NoBorder" style="text-align: left">
											{{ SoundItem.SoundFile }}
										</div>
									</div>
								</ng-template>
							</p-dropdown>

							<label>High</label>
							<p-dropdown
								[disabled]="IsSULoading() == true"
								[options]="lstSounds"
								[(ngModel)]="HighSeveritySound"
								optionLabel="SoundFile"
								[filter]="true"
								filterBy="SoundFile"
								[showClear]="false"
								placeholder="Select a Sound"
							>
								<ng-template pTemplate="selectedItem">
									<div *ngIf="HighSeveritySound">
										<div class="form-control NoBorder" style="text-align: left">
											{{ HighSeveritySound.SoundFile }}
										</div>
									</div>
								</ng-template>
								<ng-template let-SoundItem pTemplate="item">
									<div>
										<div class="form-control NoBorder" style="text-align: left">
											{{ SoundItem.SoundFile }}
										</div>
									</div>
								</ng-template>
							</p-dropdown>

							<label>Medium</label>
							<p-dropdown
								[disabled]="IsSULoading() == true"
								[options]="lstSounds"
								[(ngModel)]="MediumSeveritySound"
								optionLabel="SoundFile"
								[filter]="true"
								filterBy="SoundFile"
								[showClear]="false"
								placeholder="Select a Sound"
							>
								<ng-template pTemplate="selectedItem">
									<div *ngIf="MediumSeveritySound">
										<div class="form-control NoBorder" style="text-align: left">
											{{ MediumSeveritySound.SoundFile }}
										</div>
									</div>
								</ng-template>
								<ng-template let-SoundItem pTemplate="item">
									<div>
										<div class="form-control NoBorder" style="text-align: left">
											{{ SoundItem.SoundFile }}
										</div>
									</div>
								</ng-template>
							</p-dropdown>

							<label>Low</label>
							<p-dropdown
								[disabled]="IsSULoading() == true"
								[options]="lstSounds"
								[(ngModel)]="LowSeveritySound"
								optionLabel="SoundFile"
								[filter]="true"
								filterBy="SoundFile"
								[showClear]="false"
								placeholder="Select a Sound"
							>
								<ng-template pTemplate="selectedItem">
									<div *ngIf="LowSeveritySound">
										<div class="form-control NoBorder" style="text-align: left">
											{{ LowSeveritySound.SoundFile }}
										</div>
									</div>
								</ng-template>
								<ng-template let-SoundItem pTemplate="item">
									<div>
										<div class="form-control NoBorder" style="text-align: left">
											{{ SoundItem.SoundFile }}
										</div>
									</div>
								</ng-template>
							</p-dropdown>
						</div>
					</div>

					<div class="TopMargin CenterText">
						<button class="btn btn-primary" [disabled]="IsSULoading() == true" (click)="onUpdateSU()">Update</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
